<template>
  <div>
    <router-view></router-view>
  </div>
</template>

<script setup>

</script>

<style lang="scss" scoped>
img, video{
  -webkit-user-drag: none;
  -moz-user-drag:none;
  -o-user-drag:none;
  user-drag:none;
}
</style>